import 'semantic-ui-css/semantic.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux'
import './index.css';
import App from './app/layout/App';
import reportWebVitals from './reportWebVitals';
import store from './app/store/configureStore';



// Use createRoot to enable Concurrent Mode
const rootEl = document.getElementById('root');
const root = ReactDOM.createRoot(rootEl);

root.render(
    <Provider store={store}>
          <App />
    </Provider>
  );
// Enable HMR (Hot Module Replacement) for development
if (module.hot) {
    module.hot.accept('./app/layout/App', () => {
      root.render(
        <Provider store={store}>
              <App />
        </Provider>
      );
    });
  }
  
  // Register service worker 

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
